// http://goo.gl/XkBrjD
var $export  = require('./$.export')
  , $entries = require('./$.object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/modules/es7.object.entries.js
// module id = 255
// module chunks = 0